module.exports = __webpack_public_path__ + "static/media/NextLogo.49ae5446.png";